import { Layout as Contain } from 'antd';
import React from 'react'
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// import Footer from '../../Pages/footer';
import { LoadingContainer } from '../../styles/globalStyle';
import DownloadAlert from '../downloadAlert';
import MessageAlert from '../messageAlert';
import Switcher from '../switcher';
import Topbar from '../topbar';
import PTopbar from '../topbar/pTopbar';
import { Container } from './style';
const { Header, Content, Footer, Sider } = Contain;
const Layout = ({success,error,validationError,loading,parcent,totalSize,downloaded}) => {
  
    return ( 
        <>
          {/* {loading ? <LoadingContainer /> : null} */}
        
          {success ? <MessageAlert type="success" value={success} /> : null}
          {error ? <MessageAlert type="error" value={error} /> : null}
          {validationError ? 
            validationError.map((item,id )=> (
              <MessageAlert type="error" value={item.message} />
            ))
          :
          null
          }
          {parcent !== null ? <DownloadAlert  parcent={parcent} totalSize={totalSize} downloaded={downloaded} /> : null}

          <Contain className='site-layout'>

              <Content>
                {localStorage.getItem('token') ? <Topbar />:  null }
                <Switcher />
              </Content>
              <br />
              <br />
              <br />
              <Footer > <p style={{textAlign: 'center'}}>Copyright ©  2021-2022 Fakebuzz.net. All rights reserved.</p></Footer>
            
            </Contain> 
        </>
     );
}
const mapStateToProps = (state) => {
    return {
        success: state.helpers?.success,
        error: state.helpers?.error,
        validationError: state.helpers?.validationError,
        loading: state.helpers?.loading,
        totalSize: state.download?.totalSize,
        downloaded: state.download?.downloaded,
        parcent: state.download?.parcent,
    }
  }
 export default connect(mapStateToProps)(Layout);